import {
  ByRouteRowItem,
  VolumeAndTargetList,
} from "../../types/sales-region.types";
import { transformResultCommonFieldsToTableRow } from "./CommonTableRowTransformer";
import { ByCustomerOrVolume } from "@/features/statistics/types/ByCustomerOrVolumeEnum";
import { StatisticsResultListItem } from "@/features/statistics/config/ResultTableConfig";

export const transformResultToTableRow = (
  row: ByRouteRowItem,
  volumeAndRates: VolumeAndTargetList,
  checkedRadioButton: ByCustomerOrVolume
): StatisticsResultListItem => {
  const volumeAndTargetForSelected = volumeAndRates.find(
    (v) => v.salesRegion.id === row.salesRegion.id
  )?.volumeAndTargetForSelected;

  return {
    ownerId: row.salesRegion.id,
    ownerName: row.salesRegion.name,
    ...transformResultCommonFieldsToTableRow(row, checkedRadioButton),
    ...{
      ...volumeAndTargetForSelected,
    },
  };
};
